import ApiService from '../../services/apiService';
import LambdaApiService from '../../services/apiService/lambda';
import { mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import isEqual from 'lodash/isEqual';
import { getColumnSize } from '../../utils/bridgeUtils';
import { set } from 'lodash';
export default {
  name: 'ViewConnectorsCreate',
  data() {
    return {
      cmOptions: {
        tabSize: 4,
        mode: {
          name: 'javascript',
          json: true
        },
        firstLineNumber: 0,
        theme: this.$store.state.app.UiTheme ? 'base16-dark' : 'duotone-light',
        lineNumbers: false,
        line: true,
        foldGutter: true,
        styleActiveLine: true,
        styleSelectedText: true,
        hintOptions: {
          completeSingle: false
        },
        lineWrapping: false
      },
      connectorId: parseInt((this.$route.params || {}).id) || null,
      selectedAccount: {},
      accounts: [],
      tabItem: 'tab-metadata',
      connector: {},
      bridgeValidation: {},
      bridgeTypes: [],
      lastSavedBridge: {}
    };
  },
  computed: {
    ...mapState('app', ['color', 'inpOutlined', 'inpFilled']),
    ...mapState('authentication', ['tenantId']),
    headerBG() {
      return './img/dtwin-factory1.png';
    },
    canSave() {
      return this.connector.type !== null && this.connector.name && (this.selectedAccount || {}).id;
    },
    hasConnectionDataError() {
      return get(this.bridgeValidation, 'data.length', 0) > 0;
    },
    apiUrl() {
      return `${process.env.VUE_APP_INCOMING_WEBHOOK_HOST}/webhook?token=${this.connector.bridge.config.token}`;
    },
    apiUrlChirpstack() {
      return `${process.env.VUE_APP_CHIRPSTACK_WEBHOOK_HOST}/webhook?token=${this.connector.bridge.config.token}`;
    },
    apiUrlLwM2M() {
      return `${process.env.VUE_APP_LWM2M_SERVER_WEBHOOK_HOST}/webhook?token=${this.connector.bridge.config.token}`;
    },
    isEditMode() {
      return this.connector.id !== undefined && this.connector.id !== null;
    }
  },
  watch: {
    '$route.params.id': {
      handler(id) {
        this.connectorId = parseInt(id) || null;
        this.handleConnectorIdChange();
      },
      deep: true,
      immediate: false
    }
  },
  mounted() {
    this.fetchAccounts();
    this.loadData().then(() => {
      if (this.connectorId) {
        this.handleConnectorIdChange();

        // If query `tab` is `statuslogs` activate the tab and remove the query
        if (this.$route.query.tab === 'statuslogs') {
          this.tabItem = 'tab-statuslogs';
          this.$router.replace({
            ...this.$router.currentRoute,
            query: {
              tab: undefined
            }
          });
        }
      } else {
        this.setupNewConnector();
      }
    }).catch(error => {
      console.error(error);
      this.$snack('Error loading data', 'error');
    });
  },
  methods: {
    onMutatorScriptChange(newScript) {
      const clonedConnector = cloneDeep(this.connector);
      set(clonedConnector, 'bridge.mutator', newScript);
      this.connector = clonedConnector;
    },
    get,
    getColumnSize,
    handleTabChange(tab) {
      if (tab === 'tab-connectorlogs') {
        if (this.$refs.packetLogs) {
          this.$refs.packetLogs.fetchConnectorLogs();
        }
      } else if (tab === 'tab-statuslogs') {
        if (this.$refs.statusLogs) {
          this.$refs.statusLogs.fetchConnectorLogs();
        }
      }
    },
    handleConnectorIdChange() {
      // check if connector with id exists
      // - if not, go back to connectors list
      // - if yes, set connector data
      const connector = cloneDeep(this.bridges.find(bridge => bridge.id === this.connectorId));
      if (!connector) {
        this.$router.replace('/connectors/list');
        return;
      }
      this.connector = connector;
      this.lastSavedBridge = cloneDeep(connector);
      this.selectedAccount = this.accounts.find(account => account.id === this.connector.tenantId);
    },
    setupNewConnector() {
      this.bridgeValidations = {};
      this.connector = {
        name: this.$i18n_t('accMgmt.tenant.bridges.newBridge'),
        type: null,
        bridge: {
          config: {}
        },
        config: {
          parser: {}
        }
      };
    },
    fetchAccounts() {
      this.$store.dispatch('app/loadAccounts').then(accounts => {
        this.accounts = accounts;
      }).catch(error => {
        console.error(error);
        this.$snack(this.$i18n_t('NiotaClassic.Devices.snacks.errorFindingAccounts'), 'error');
      });
    },
    loadData() {
      this.isLoadingConnectors = true;
      this.bridgeTypes = [];
      this.bridges = [];
      return Promise.all([this.loadBridgeTypes(), this.loadBridgeConfigs()]).then(([types, configs]) => {
        this.bridgeTypes = types.map(type => {
          return {
            ...type,
            name: get(type, 'manifest.displayName')
          };
        }).sort((b1, b2) => {
          if (b1.name > b2.name) {
            return 1;
          }
          if (b1.name < b2.name) {
            return -1;
          }
          return 0;
        });
        this.bridges = configs.map(config => {
          const bridgeType = this.bridgeTypes.find(t => t.type === config.type);
          config.displayName = bridgeType ? get(bridgeType, 'manifest.displayName') : '';
          return config;
        });
        if (this.$route.query.showBridges !== undefined) {
          this.scrollBridgesIntoView();
        }
      }).catch(error => {
        console.error(error);
        this.$snack(this.$i18n_t('Common.errorLoadingData'), 'error');
      }).finally(() => {
        this.isLoadingConnectors = false;
      });
    },
    loadBridgeTypes() {
      return ApiService.getBridgeTypes();
    },
    loadBridgeConfigs() {
      return ApiService.getBridgesForTenant(this.$route.params.account || this.tenantId);
    },
    bridgeConfigIsInbound(bridge) {
      return get(bridge, 'manifest.functionScope.invokeDirection.inbound', false);
    },
    bridgeConfigIsOutbound(bridge) {
      return get(bridge, 'manifest.functionScope.invokeDirection.outbound', false);
    },
    bridgeConfig(bridge) {
      return this.bridgeTypes.find(config => config.type === bridge.type);
    },
    bridgeConfigKeys(instance) {
      const bridgeManifest = this.bridgeConfig(instance).manifest;
      let keys = Object.keys(bridgeManifest.config[0]).filter(key => {
        if (get(bridgeManifest, `config[0][${key}].hidden`)) {
          return false;
        }
        // if field is readonly, only show if it has a value
        if (get(bridgeManifest, `config[0][${key}].readonly`)) {
          return !!instance.bridge.config[key];
        }
        const visibleConfig = get(bridgeManifest, `config[0][${key}].visible`) || {};
        return Object.keys(visibleConfig).every(dependentKey => {
          return instance.bridge.config[dependentKey] === visibleConfig[dependentKey];
        });
      });
      return keys.sort((a, b) => {
        const orderIdxA = get(bridgeManifest, `config[0][${a}].orderIdx`) || 0;
        const orderIdxB = get(bridgeManifest, `config[0][${b}].orderIdx`) || 0;
        if (orderIdxA < orderIdxB) {
          return -1;
        }
        if (orderIdxA > orderIdxB) {
          return 1;
        }
        return a.localeCompare(b);
      });
    },
    bridgeHasValidParameters(strict = false) {
      let currentParameters = get(this.connector, 'bridge.config');
      let savedParameters = get(this.lastSavedBridge, 'bridge.config');
      return !get(this.bridgeValidation, 'error', strict ? true : !isEqual(currentParameters, savedParameters));
    },
    changedBridgeParams() {
      this.bridgeValidation = {};
    },
    shouldShowTemplateSelect(bridgeInstance) {
      const bridgeConfig = this.bridgeConfig(bridgeInstance);
      const templates = bridgeConfig.manifest.templates || [];
      return bridgeConfig.manifest.functionScope.invokeDirection.inbound && (templates.length > 1 || bridgeConfig.manifest.functionScope.editableMutator);
    },
    editConfigMutator(bridge) {
      if (bridge.bridge.mutator) {
        delete bridge.bridge.mutator;
        this.bridgeValidation = cloneDeep(this.bridgeValidation);
        return;
      }
      const template = this.bridgeConfig(bridge).manifest.templates.find(template => {
        return template.name === bridge.config.parser.script;
      });
      bridge.bridge.mutator = get(template, 'mutator.script');
      bridge.bridge = cloneDeep(bridge.bridge);
      this.bridgeValidation = cloneDeep(this.bridgeValidation);
    },
    validateConnector() {
      const scriptToEval = this.connector.bridge.mutator;
      const promiseValidate = ApiService.validateBridge(this.connector.type, this.connector.id, this.connector.bridge.config);
      const promiseEvalMutator = scriptToEval ? LambdaApiService.evaluateScript({
        script: scriptToEval,
        scriptParams: [{}]
      }) : Promise.resolve({});
      Promise.all([promiseValidate, promiseEvalMutator]).then(([validationResult, mutatorResult]) => {
        const bridgeInstance = this.connector;
        const bridgeManifest = this.bridgeConfig(bridgeInstance).manifest;
        if (get(bridgeManifest, 'functionScope.validator.returnsConfig')) {
          // (parts of) the config is returned/calculated for this bridge-validator,
          // so overwrite/merge with the existing config
          bridgeInstance.bridge.config = {
            ...bridgeInstance.bridge.config,
            ...validationResult.data
          };
        }
        let errorMessage = get(validationResult, 'errorMessage', get(mutatorResult, 'error'));
        this.bridgeValidation = validationResult;
        this.connector.hasError = true;
        if (mutatorResult.syntaxError) {
          this.bridgeValidation = {
            ...mutatorResult,
            mutatorScriptError: true
          };
        }
        if (errorMessage) {
          this.$snack(errorMessage, 'error');
        } else {
          this.persistBridge();
        }
      }).catch(error => {
        console.error(error);
      });
    },
    persistBridge() {
      let persistPromise = Promise.resolve();
      if (this.connector.id) {
        persistPromise = ApiService.updateBridge(this.connector.id, this.connector);
      } else {
        persistPromise = ApiService.createBridge(this.selectedAccount.id, this.connector.type, this.connector);
      }
      return persistPromise.then(persistedBridge => {
        this.connector = persistedBridge;
        this.lastSavedBridge = persistedBridge;
        this.$snack(this.$i18n_t('Connectors.Connectors.saveSuccess'), 'success');
      }).catch(error => {
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(`${error.response.data.message}`, 'error');
        }
      });
    },
    resetBridgeState() {
      ApiService.resetBridgeState(this.connector.id, 'waiting').then(persistedBridge => {
        this.connector = persistedBridge;
      }).catch(error => {
        console.error(error);
        this.$snack(error, 'error');
      });
    }
  }
};